/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EStatutContrat } from './EStatutContrat';
import {
    EStatutContratFromJSON,
    EStatutContratFromJSONTyped,
    EStatutContratToJSON,
} from './EStatutContrat';

/**
 * 
 * @export
 * @interface DashboardAvisResultatDto
 */
export interface DashboardAvisResultatDto {
    /**
     * 
     * @type {number}
     * @memberof DashboardAvisResultatDto
     */
    idbulletinApprenantType?: number;
    /**
     * 
     * @type {number}
     * @memberof DashboardAvisResultatDto
     */
    idapprenant?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DashboardAvisResultatDto
     */
    revalidated?: boolean;
    /**
     * 
     * @type {EStatutContrat}
     * @memberof DashboardAvisResultatDto
     */
    statutContrat?: EStatutContrat;
    /**
     * 
     * @type {string}
     * @memberof DashboardAvisResultatDto
     */
    anneeScolaire?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardAvisResultatDto
     */
    concerne?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardAvisResultatDto
     */
    metierStade?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardAvisResultatDto
     */
    typeCours?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DashboardAvisResultatDto
     */
    masque?: boolean;
}

/**
 * Check if a given object implements the DashboardAvisResultatDto interface.
 */
export function instanceOfDashboardAvisResultatDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DashboardAvisResultatDtoFromJSON(json: any): DashboardAvisResultatDto {
    return DashboardAvisResultatDtoFromJSONTyped(json, false);
}

export function DashboardAvisResultatDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardAvisResultatDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idbulletinApprenantType': !exists(json, 'idbulletinApprenantType') ? undefined : json['idbulletinApprenantType'],
        'idapprenant': !exists(json, 'idapprenant') ? undefined : json['idapprenant'],
        'revalidated': !exists(json, 'revalidated') ? undefined : json['revalidated'],
        'statutContrat': !exists(json, 'statutContrat') ? undefined : EStatutContratFromJSON(json['statutContrat']),
        'anneeScolaire': !exists(json, 'anneeScolaire') ? undefined : json['anneeScolaire'],
        'concerne': !exists(json, 'concerne') ? undefined : json['concerne'],
        'metierStade': !exists(json, 'metierStade') ? undefined : json['metierStade'],
        'typeCours': !exists(json, 'typeCours') ? undefined : json['typeCours'],
        'masque': !exists(json, 'masque') ? undefined : json['masque'],
    };
}

export function DashboardAvisResultatDtoToJSON(value?: DashboardAvisResultatDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idbulletinApprenantType': value.idbulletinApprenantType,
        'idapprenant': value.idapprenant,
        'revalidated': value.revalidated,
        'statutContrat': EStatutContratToJSON(value.statutContrat),
        'anneeScolaire': value.anneeScolaire,
        'concerne': value.concerne,
        'metierStade': value.metierStade,
        'typeCours': value.typeCours,
        'masque': value.masque,
    };
}

